angular.module('blc').controller('OffersCtrl', ['$scope', 'JSONLD', 'quote', function ($scope,JSONLD, quote) {
  $scope.quote = quote;
  $scope.offers = JSONLD.hotoffers;
  $scope.quote_status = false;
  $scope.$watch( function() { return quote.ready(); }, function(quote_status) { $scope.quote_ready = quote_status; });

}]);



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/hotoffer_ctrl.js
 ** module id = 28
 ** module chunks = 0
 **/